export default "__VITE_ASSET__V4a0P81A__"